import {Component} from 'react'
import Popup from 'reactjs-popup'
import {RiCloseLine} from 'react-icons/ri'
import {
  PopupContainer,
  CloseButton,
  RulesImage,
  TriggerButton,
} from './styledComponents'

class RulesPopup extends Component {
  render() {
    return (
      <Popup
        modal
        trigger={<TriggerButton type="button">Rules</TriggerButton>}
        className="popup-content"
      >
        {close => (
          <PopupContainer>
            <CloseButton type="button" onClick={close}>
              <RiCloseLine size={20} />
            </CloseButton>
            <RulesImage
              src="https://assets.ccbp.in/frontend/react-js/rock-paper-scissor/rules-image.png"
              alt="rules"
            />
          </PopupContainer>
        )}
      </Popup>
    )
  }
}

export default RulesPopup
